const ValueAction = {
  VALUE_SET: 'VALUE_SET',
  CLEAR_ALL: 'CLEAR_ALL',
};

export default ValueAction;
